const responses = [
    {id: 1, title: 'Purchase Response'},
    {id: 2, title: 'Pre-Authorization Response'},
    {id: 3, title: 'Pre-Auth Completion Response'},
    {id: 4, title: 'Force Post Response'},
    {id: 5, title: 'Purchase Correction Response'},
    {id: 6, title: 'Refund Response'},
    {id: 7, title: 'Independent Refund Response'},
    {id: 8, title: 'Card Verification Response'},
    {id: 9, title: 'Batch Close Response'},
    {id: 10, title: 'Open Totals Response'},
]

export default responses